import { observer } from "mobx-react-lite";
import { useState } from "react";
import { Container } from "./components";
import { Store, StoreContext } from "./store";

export const Module = observer(function Module() {
  const [store] = useState(() => new Store());
  return (
    <StoreContext.Provider value={store}>
      <Container />
    </StoreContext.Provider>
  );
});
